import { IconProps } from './types';

const CloudOff = ({ color, dimension }: IconProps) => (
  <svg
    fill="none"
    height={dimension || 24}
    viewBox="0 0 24 24"
    width={dimension || 24}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1027_7059)">
      <path
        d="M22.61 16.95C22.9322 16.1893 23.0609 15.3606 22.9845 14.5381C22.9082 13.7155 22.6293 12.9246 22.1726 12.2362C21.716 11.5478 21.0959 10.9832 20.3677 10.593C19.6396 10.2027 18.8261 9.99902 18 10H16.74C16.3318 8.39249 15.4341 6.95158 14.171 5.87666C12.908 4.80173 11.3421 4.14593 9.69 4M5 5C3.43808 5.86364 2.20981 7.22478 1.51059 8.86691C0.811366 10.509 0.681351 12.3378 1.14123 14.0623C1.6011 15.7869 2.62445 17.3081 4.04848 18.384C5.47251 19.4599 7.21544 20.0288 9 20H18C18.5798 19.9993 19.155 19.8978 19.7 19.7M0.999999 1L23 23"
        stroke={color || '#101828'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </g>
    <defs>
      <clipPath id="clip0_1027_7059">
        <rect fill="white" height={dimension || 24} width={dimension || 24} />
      </clipPath>
    </defs>
  </svg>
);

export default CloudOff;
